import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import QBtn from 'quasar/src/components/btn/QBtn.js';
import { ref, computed } from 'vue'
import { getRelatedColors } from '../utils/colorUtils'


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: 'secondary',
  },
  textColor: {
    type: String,
    default: undefined,
  },
  slideEffectColor: {
    type: String,
    default: undefined,
  },
  to: {
    type: [String, Object],
    default: undefined,
  },
  icon: {
    type: String,
    default: undefined,
  },
  iconSize: {
    type: [String, Number],
    default: undefined,
  },
  iconClass: {
    type: String,
    default: undefined,
  },
  tooltip: {
    type: String,
    default: undefined,
  },
  tooltipLeft: {
    type: String,
    default: undefined,
  },
  tooltipRight: {
    type: String,
    default: undefined,
  },
  small: Boolean,
  disable: Boolean,
  loading: Boolean,
},
  setup(__props) {

const props = __props



const button = ref<InstanceType<typeof QBtn> | null>(null)

const iconSize = computed(() => {
  return props.iconSize || (props.small ? 18 : 24)
})

const computedTextColor = computed(() => {
  if (props.textColor) {
    return props.textColor
  }

  const color = props.color
  const relatedColors = getRelatedColors(color)

  return relatedColors ? relatedColors.onColor : 'grey-darkest'
})

const buttonDataId = computed(() => {
  return button.value?.$el.dataset?.id
})

const tooltipDataId = computed(() => {
  return buttonDataId.value ? `${buttonDataId.value}-tooltip` : 'tile-btn-tooltip'
})

const tooltipLeftDataId = computed(() => {
  return buttonDataId.value ? `${buttonDataId.value}-tooltip-left` : 'tile-btn-tooltip-left'
})

const tooltipRightDataId = computed(() => {
  return buttonDataId.value ? `${buttonDataId.value}-tooltip-right` : 'tile-btn-tooltip-right'
})


return (_ctx: any,_cache: any) => {
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_c_slide_effect = _resolveComponent("c-slide-effect")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_tooltip = _resolveComponent("c-tooltip")!

  return (_openBlock(), _createBlock(_unref(QBtn), {
    ref_key: "button",
    ref: button,
    class: _normalizeClass(["c-tile-btn group", {
      'c-tile-btn--small': __props.small,
      'pointer-events-none': __props.loading
    }]),
    unelevated: "",
    color: __props.color,
    to: __props.to,
    "text-color": _unref(computedTextColor),
    disable: __props.disable,
    "aria-label": __props.tooltip || __props.tooltipLeft || __props.tooltipRight
  }, {
    default: _withCtx(() => [
      (__props.loading)
        ? (_openBlock(), _createBlock(_component_c_spinner, {
            key: 0,
            "parent-color": __props.color,
            size: __props.small ? 24 : 60,
            absolute: "",
            gap: "0",
            class: "-z-1"
          }, null, 8, ["parent-color", "size"]))
        : _createCommentVNode("", true),
      (!__props.disable)
        ? (_openBlock(), _createBlock(_component_c_slide_effect, {
            key: 1,
            "parent-color": __props.color,
            "slide-effect-color": __props.slideEffectColor,
            "slide-right": "",
            class: "-z-1"
          }, null, 8, ["parent-color", "slide-effect-color"]))
        : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 2,
            name: __props.icon,
            style: _normalizeStyle(`font-size: ${_unref(iconSize)}px`),
            class: _normalizeClass(__props.iconClass)
          }, null, 8, ["name", "style", "class"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (__props.tooltip)
        ? (_openBlock(), _createBlock(_component_c_tooltip, {
            key: 3,
            "data-id": _unref(tooltipDataId)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltip), 1)
            ]),
            _: 1
          }, 8, ["data-id"]))
        : _createCommentVNode("", true),
      (__props.tooltipLeft)
        ? (_openBlock(), _createBlock(_component_c_tooltip, {
            key: 4,
            "data-id": _unref(tooltipLeftDataId),
            left: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltipLeft), 1)
            ]),
            _: 1
          }, 8, ["data-id"]))
        : _createCommentVNode("", true),
      (__props.tooltipRight)
        ? (_openBlock(), _createBlock(_component_c_tooltip, {
            key: 5,
            "data-id": _unref(tooltipRightDataId),
            right: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltipRight), 1)
            ]),
            _: 1
          }, 8, ["data-id"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "color", "to", "text-color", "disable", "aria-label"]))
}
}

})